module.exports = __webpack_public_path__ + "img/reglamentoarbitrajepoomsaes.3ea3001a.png";